import { render } from "./modal.vue?vue&type=template&id=25fcdb42&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=25fcdb42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25fcdb42"

export default script